import React from "react";

import NaytaKortti from "./NaytaKortti";

const LuuppaaKortit = (props) => {
  const { tila, asetatila } = props;
  const kortit = tila.kortit;
  // alert("kortit pituus" + kortit.length);
  return kortit.map((tuote) => (
    <div className="kortti" key={tuote.Ttunnus}>
      <NaytaKortti
        tila={tila}
        asetatila={asetatila}
        tuoteId={tuote.Ttunnus}
      />
    </div>
  ));
};

const NaytaKortit = (props) => {
  const { tila, asetatila } = props;
  if (tila.kortit.length)
    return (
      <div className="ruudukko">
        <LuuppaaKortit tila={tila} asetatila={asetatila} />
      </div>
    );
  else return null;
};

export default NaytaKortit;
